import React from 'react';
import './TabComponent.css';

import EnglishForm from './EnglishForm';
import ArabicForm from './ArabicForm';
import SocialTab from './SocialTab';
import ImageTab from './ImageTab';
import {connect} from "react-redux";

class TabComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			count: 1,

		};
	}

	showForm = () => {
		if (this.props.count === 2) {
			return (<SocialTab/>);
		} else if (this.props.count === 3) {return (<ImageTab/>);}
	};

	handleLanguageForm = () => {
		switch (this.props.language_web) {
			case 'English' :
				return (<EnglishForm/>);
			case 'العربية' :
				return (<ArabicForm/>);
			default:
				return (<ArabicForm/>);
		}
	};

	render() {

		return (
				<div>
					{(this.props.count === 1) ? this.handleLanguageForm() : this.showForm()}

				</div>
		);

	}
}


function mapStateToProps(state) {
	return {
		language_web: state.LanguageReducer.languageWeb,
	};
}


export default connect(mapStateToProps)(TabComponent);
